/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { Component, Input, Output, HostBinding } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { NbCardService } from './card.service';


/**
 * Component intended to be used within  the `<nb-card>` component.
 * It adds styles for a preset header section.
 */
@Component({
  selector: 'nb-card-header',
  template: `<ng-content>  </ng-content>`,
})
export class NbCardHeaderComponent {
  fullscreen = false;

  constructor(private nbCardService: NbCardService) {
  }

  toggleFullscreen(): void {
    this.fullscreen = !this.fullscreen;
    this.nbCardService.cardSizeChange(this.fullscreen);
    console.info(this.fullscreen);
  }
}

/**
 * Component intended to be used within  the `<nb-card>` component.
 * It adds styles for a preset body section.
 */
@Component({
  selector: 'nb-card-body',
  template: `<ng-content></ng-content>`,
})
export class NbCardBodyComponent {
}

/**
 * Component intended to be used within  the `<nb-card>` component.
 * It adds styles for a preset header tools section.
 */
@Component({
  selector: 'nb-card-tools',
  template: ` `,
})
export class NbCardToolsComponent {
  // private fullscreen: boolean = false;
}

/**
 * Component intended to be used within  the `<nb-card>` component.
 * It adds styles for a preset footer section.
 */
@Component({
  selector: 'nb-card-footer',
  template: `<ng-content></ng-content>`,
})
export class NbCardFooterComponent {
}

/**
 * A basic content container component
 *
 * While this component can be used alone, it also provides a number
 * of child components for common card sections, including:
 * - nb-card-header
 * - nb-card-body
 * - nb-card-footer
 */
@Component({
  selector: 'nb-card',
  providers: [NbCardService],
  styleUrls: ['./card.component.scss'],
  template: `
    <ng-content></ng-content>
    <ng-content select="nb-card-header"></ng-content>
    <ng-content select="nb-card-body"></ng-content>
    <ng-content select="nb-card-footer"></ng-content>
  `,
})
export class NbCardComponent {

  fs: boolean;
  subscription: Subscription;

  constructor(private nbCardService: NbCardService) {
    this.subscription = this.nbCardService.getMessage().subscribe(
      fullscreen => {
        this.fs = fullscreen;
      });
  }

  static readonly SIZE_XXSMALL = 'xxsmall';
  static readonly SIZE_XSMALL = 'xsmall';
  static readonly SIZE_SMALL = 'small';
  static readonly SIZE_MEDIUM = 'medium';
  static readonly SIZE_LARGE = 'large';
  static readonly SIZE_XLARGE = 'xlarge';
  static readonly SIZE_XXLARGE = 'xxlarge';

  // static readonly FULLSCREEN = 'fullscreen';

  static readonly GREEN = 'green';
  static readonly BLUE = 'blue';
  static readonly RED = 'red';
  static readonly PURPLE = 'purple';

  static readonly STATUS_PRIMARY = 'primary';
  static readonly STATUS_SUCESS = 'success';
  static readonly STATUS_INFO = 'info';
  static readonly STATUS_WARNING = 'warning';
  static readonly STATUS_DANGER = 'danger';

  static readonly TYPE_NORMAL = 'normal';
  static readonly TYPE_TABLE = 'table';

  size: string;
  status: string;
  type: string;

  @HostBinding('class.xxsmall-card')
  private get xxsmall() {
    return this.size === NbCardComponent.SIZE_XXSMALL;
  }

  @HostBinding('class.xsmall-card')
  private get xsmall() {
    return this.size === NbCardComponent.SIZE_XSMALL;
  }

  @HostBinding('class.small-card')
  private get small() {
    return this.size === NbCardComponent.SIZE_SMALL;
  }

  @HostBinding('class.medium-card')
  private get medium() {
    return this.size === NbCardComponent.SIZE_MEDIUM;
  }

  @HostBinding('class.large-card')
  private get large() {
    return this.size === NbCardComponent.SIZE_LARGE;
  }

  @HostBinding('class.xlarge-card')
  private get xlarge() {
    return this.size === NbCardComponent.SIZE_XLARGE;
  }

  @HostBinding('class.xxlarge-card')
  private get xxlarge() {
    return this.size === NbCardComponent.SIZE_XXLARGE;
  }

  @HostBinding('class.green')
  private get green() {
    return this.status === NbCardComponent.GREEN;
  }

  @HostBinding('class.blue')
  private get blue() {
    return this.status === NbCardComponent.BLUE;
  }

  @HostBinding('class.red')
  private get red() {
    return this.status === NbCardComponent.RED;
  }

  @HostBinding('class.purple')
  private get purple() {
    return this.status === NbCardComponent.PURPLE;
  }

  @HostBinding('class.primary-card')
  private get primary() {
    return this.status === NbCardComponent.STATUS_PRIMARY;
  }
  @HostBinding('class.success-card')
  private get sucess() {
    return this.status === NbCardComponent.STATUS_SUCESS;
  }
  @HostBinding('class.info-card')
  private get info() {
    return this.status === NbCardComponent.STATUS_INFO;
  }

  @HostBinding('class.warning-card')
  private get warning() {
    return this.status === NbCardComponent.STATUS_WARNING;
  }
  @HostBinding('class.danger-card')
  private get danger() {
    return this.status === NbCardComponent.STATUS_DANGER;
  }
  @HostBinding('class.table-card')
  private get table() {
    return this.type === NbCardComponent.TYPE_TABLE;
  }

  @HostBinding('class.fullscreen')
  private get screen() {
    return this.fs;
  }

  @Input('size')
  private set setSize(val: string) {
    this.size = val;
  }

  @Input('status')
  private set setStatus(val: string) {
    this.status = val;
  }

  @Input('type')
  private set setType(val: string) {
    this.type = val;
  }



}



// WEBPACK FOOTER //
// ./src/framework/theme/components/card/card.component.ts